import * as THREE from 'three';

/**
 * Keyed cache for shared materials. The point isn't creation convenience —
 * it's that hundreds/thousands of meshes (trees, bunkers, terrain tiles)
 * should share one Material instance per visual "kind" rather than each
 * minting its own, which matters for both memory and draw-call batching
 * once real content lands.
 */
export class MaterialManager {
  private readonly cache = new Map<string, THREE.Material>();

  getOrCreate<T extends THREE.Material>(key: string, factory: () => T): T {
    const existing = this.cache.get(key);
    if (existing) return existing as T;

    const material = factory();
    this.cache.set(key, material);
    return material;
  }

  dispose(key: string): void {
    this.cache.get(key)?.dispose();
    this.cache.delete(key);
  }

  disposeAll(): void {
    for (const material of this.cache.values()) material.dispose();
    this.cache.clear();
  }
}
